/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Record_WorkflowVersionDefinitionStep_at_id_WorkflowStepExecution_at_error_ } from './Record_WorkflowVersionDefinitionStep_at_id_WorkflowStepExecution_at_error_';
import type { WorkflowExecutionInputs } from './WorkflowExecutionInputs';
/**
 * TSOA-compatible workflow execution.
 */
export type TCWorkflowExecution = {
    createdAt: string;
    updatedAt: string;
    inputs: WorkflowExecutionInputs;
    tenantId: string;
    status: TCWorkflowExecution.status;
    workflowId: string;
    executionId: string;
    stepErrors?: Record_WorkflowVersionDefinitionStep_at_id_WorkflowStepExecution_at_error_;
    parentExecution?: {
        stepId: string;
        id: string;
    };
    rootExecutionId: string;
    executionDepth: number;
    version: (string | number);
};
export namespace TCWorkflowExecution {
    export enum status {
        RUNNING = 'running',
        COMPLETED = 'completed',
        FAILED = 'failed',
    }
}

